import { all } from 'redux-saga/effects'

/* sagas from @galo-monitor/stores */
import sagasActivity from '@galo-monitor/stores/activity/sagasActivity'
import sagasApplication from '@galo-monitor/stores/application/sagasApplication'
import sagasAuthentication from '@galo-monitor/stores/authentication/sagasAuthentication'
import sagasBrand from '@galo-monitor/stores/brand/sagasBrand'
import sagasBreeding from '@galo-monitor/stores/breeding/sagasBreeding'
import sagasCompany from '@galo-monitor/stores/company/sagasCompany'
import sagasCompanyUser from '@galo-monitor/stores/companyUser/sagasCompanyUser'
import sagasContext from '@galo-monitor/stores/context/sagasContext'
import sagasCultivar from '@galo-monitor/stores/cultivar/sagasCultivar'
import sagasCulture from '@galo-monitor/stores/culture/sagasCulture'
import sagasFarm from '@galo-monitor/stores/farm/sagasFarm'
import sagasFarmUser from '@galo-monitor/stores/farmUser/sagasFarmUser'
import sagasFertilizer from '@galo-monitor/stores/fertilizer/sagasFertilizer'
import sagasMachine from '@galo-monitor/stores/machine/sagasMachine'
import sagasModel from '@galo-monitor/stores/model/sagasModel'
import sagasModule from '@galo-monitor/stores/module/sagasModule'
import sagasPesticide from '@galo-monitor/stores/pesticide/sagasPesticide'
import sagasPlan from '@galo-monitor/stores/plan/sagasPlan'
import sagasProject from '@galo-monitor/stores/project/sagasProject'
import sagasProperty from '@galo-monitor/stores/property/sagasProperty'
import sagasRawMaterialsStocks from '@galo-monitor/stores/rawMaterialsStocks/sagasRawMaterialsStocks'
import sagasRole from '@galo-monitor/stores/role/sagasRole'
import sagasUser from '@galo-monitor/stores/user/sagasUser'

export default function* root() {
  yield all([
    ...sagasActivity,
    ...sagasApplication,
    ...sagasAuthentication,
    ...sagasBrand,
    ...sagasBreeding,
    ...sagasCompany,
    ...sagasCompanyUser,
    ...sagasContext,
    ...sagasCultivar,
    ...sagasCulture,
    ...sagasFarm,
    ...sagasFarmUser,
    ...sagasFertilizer,
    ...sagasMachine,
    ...sagasModel,
    ...sagasModule,
    ...sagasPesticide,
    ...sagasPlan,
    ...sagasProperty,
    ...sagasRawMaterialsStocks,
    ...sagasRole,
    ...sagasProject,
    ...sagasUser
  ])
}
